import React from 'react'
import PropTypes from 'prop-types'

import ChannelPartner from '/models/channel-partner'

export default \
class ChannelPartnerForm extends React.Component
  @propTypes =
    channel_partner:  PropTypes.object
    cancel:           PropTypes.func.isRequired
    save:             PropTypes.func.isRequired
    disabled:         PropTypes.bool.isRequired

  constructor: (props)->
    super arguments...
    @state =
      channel_partner: ChannelPartner.parse @props.channel_partner or {}

  update: (field, evt)=>
    value = evt?.target?.value ? evt
    @state.channel_partner["#{field}"] = value
    @setState channel_partner: @state.channel_partner

  cancel: (evt)=>
    evt.preventDefault()
    @setState channel_partner: ChannelPartner.parse {}
    @props.cancel()

  save: (evt)=>
    evt.preventDefault()
    {errors} = await @props.save @state.channel_partner
    @cancel evt unless errors?.length

  render: ->
    <div className="ChannelPartnerForm">
      <form>
        <div className="form-group">
          <label className="control-label">Name</label>
          <input
            type='text'
            value={@state.channel_partner.name or ''}
            required
            className='form-control'
            placeholder='Partner Name'
            onChange={@update.bind @, 'name'}
          />
        </div>
        <div className="form-group">
          <label className="control-label">TM Identifier</label>
          <input
            type='text'
            value={@state.channel_partner.tm_identifier or ''}
            required
            className='form-control'
            placeholder='TM Identifier'
            onChange={@update.bind @, 'tm_identifier'}
          />
        </div>
        <div className="form-group">
          <label className="control-label">Note</label>
          <textarea
            value={@state.channel_partner.note or ''}
            className='form-control'
            placeholder='Optional note'
            rows={3}
            onChange={@update.bind @, 'note'}
          />
        </div>
        <div className='buttons'>
          <button className='btn btn-default' onClick={@cancel} disabled={@props.disabled}>Cancel</button>
          <button className='btn btn-primary' onClick={@save} disabled={@props.disabled}>
            {if @props.channel_partner then 'Save' else 'Create'}
          </button>
        </div>
      </form>
    </div>
